import React, { useEffect, useState } from "react";
import FormField from "../../Components/FormField/FormField";
import CheckableButton from "../../Components/CheckableButton/CheckableButton";
import SuperAnnButton from "../../Components/CheckableButton/SuperAnnButton";
import ButtonContainer from "../../Components/CheckableButton/ButtonContainer";
import { getStates } from "../../Helper";
import { API } from "../../API"

const states = getStates();

function SuperForm(props) {
  const [tfn, setTFN] = useState("");
  const { state } = props;

  useEffect(() => {
    console.log("user: ", props.user);
    API.getSafeBankData().then(res => {
      if (res.data.bank_details && res.data.bank_details.tfn) {
        //console.log("tfn: ", res.data.bank_details.tfn);
        setTFN(res.data.bank_details.tfn)
      }
    });
  }, []);

  return (
    <>
      <div className="row">
        {/* {/* <div className="col-lg-6"> */}
        {/* <div className="auth-text-top mb-5"> */}
        <div className="col mb-5">
          <ButtonContainer
            superAnn
            className='d-flex justify-content-around'
            label="Please nominate a superannuation fund category"
          >
            <SuperAnnButton
              id="default"
              name="fund_category"
              className='d-none'
              value="3"
              onChange={props.handleSuperTypeChange}
              required
              checked={state.fund_type === "default"}
            >
              ReadyTeacher's Default Super Fund (AustralianSuper)
            </SuperAnnButton>
            <SuperAnnButton
              id="regulated"
              name="fund_category"
              value="1"
              onChange={props.handleSuperTypeChange}
              required
              checked={state.fund_type === "regulated"}
            >
              Regulated Super Fund
            </SuperAnnButton>
            {/* <label> OR </label> */}
            <SuperAnnButton
              id="self-managed"
              name="fund_category"
              value="2"
              onChange={props.handleSuperTypeChange}
              required
              checked={state.fund_type === "self-managed"}
            >
              Self-Managed Super Fund
            </SuperAnnButton>
            {/* <label> OR </label> */}
            <SuperAnnButton
              id="stapled"
              name="fund_category"
              className='d-none'
              value="4"
              onChange={props.handleSuperTypeChange}
              required
              checked={state.fund_type === "stapled"}
            >
              Stapled Super Fund Details (If choice of fund is not selected)
            </SuperAnnButton>

          </ButtonContainer>
        </div>
      </div>

      {/* regulated super fund */}
      <div
        className="row mb-5"
        style={{ display: state.fund_type === "regulated" ? "flex" : "none" }}
      >
        <div className="col-md-6">
          <FormField
            id="fund_name"
            label="Fund Name"
            placeholder="Fund Name"
            required={state.fund_type === "regulated"}
            onChange={props.handleFormFieldChange}
            value={state.fund_name}
          />
          <FormField
            id="usi"
            label="USI"
            placeholder="USI"
            required={state.fund_type === "regulated"}
            onChange={props.handleFormFieldChange}
            value={state.usi}
          />
        </div>
        <div className="col-md-6">
          <FormField
            id="fund_abn"
            label="Fund ABN"
            placeholder="Fund ABN"
            required={state.fund_type === "regulated"}
            onChange={props.handleFormFieldChange}
            value={state.fund_abn}
          />
          <FormField
            id="member_number"
            label="Member Number"
            placeholder="Member Number"
            onChange={props.handleFormFieldChange}
            required={state.fund_type === "regulated"}
            value={state.member_number}
          />
        </div>
      </div>

      {/* self-managed super fund */}
      <div
        className="row mb-5"
        style={{
          display: state.fund_type === "self-managed" ? "flex" : "none",
        }}
      >
        <div className="col-md-6">
          <FormField
            id="fund_name2"
            label="Fund Name"
            placeholder="Fund Name"
            onChange={props.handleFormFieldChange}
            required={state.fund_type === "self-managed"}
            value={state.fund_name2}
          />
          <FormField
            id="fund_abn2"
            label="Fund ABN"
            placeholder="Fund ABN"
            onChange={props.handleFormFieldChange}
            required={state.fund_type === "self-managed"}
            value={state.fund_abn2}
          />
          <FormField
            id="member_number2"
            label="Member Number"
            placeholder="Member Number"
            onChange={props.handleFormFieldChange}
            required={state.fund_type === "self-managed"}
            value={state.member_number2}
          />
        </div>
        <div className="col-md-6">
          <FormField
            id="fund_bsb"
            label="Fund BSB"
            placeholder="Fund BSB"
            onChange={props.handleFormFieldChange}
            required={state.fund_type === "self-managed"}
            value={state.fund_bsb}
          />
          <FormField
            id="fund_bank_acc_no"
            label="Fund Bank Account Number"
            placeholder="Fund Bank Account Number"
            onChange={props.handleFormFieldChange}
            required={state.fund_type === "self-managed"}
            value={state.fund_bank_acc_no}
          />
        </div>
      </div>

      {/* readyteacher's super */}
      <div
        className="mb-5"
        style={{ display: state.fund_type === "default" ? "block" : "none" }}
      >
        <label>Fund Name: Australian Super</label>
        <br />
        <label>USI: STA0100AU</label>
        <br />
        <label>Fund ABN: 65 714 394 898</label>
        <br />
        <label>Fund Phone: 1300 300 273</label>
        <br />
        <label>AustralianSuper will notify you of your member number.</label>

        <ButtonContainer horizontal>
          <CheckableButton
            id="authorize"
            name="authorize"
            checkbox
            required={state.fund_type === "default"}
          >
            I authorise ReadyTeacher to create an account with AustralianSuper
            for the purposes of making superannuation payments
          </CheckableButton>
        </ButtonContainer>
      </div>

      {/* stapled super fund - where an employee does not complete choice of fund, the employer requires these stated info */}
      <div
        className="row mb-5"
        style={{ display: state.fund_type === "stapled" ? "flex" : "none" }}
      >
        {/* <label>Stapled fund search is required if none options are selected</label> */}
        <div className="col-md-6">
          <FormField
            id="first_name"
            label="First Name"
            value={props.user.first_name}
            disabled
          />
          <FormField
            id="middle_name"
            label="Middle Name (Optional)"
            value={props.user.middle_name}
            disabled
          />
          <FormField
            label="Last Name"
            id="last_name"
            value={props.user.last_name}
            disabled
          />
        </div>

        <div className="col-md-6">
          <FormField
            id="date_of_birth"
            label="Date of Birth"
            value={props.user.date_of_birth}
            disabled
          />
          <FormField
            id="tfn"
            label="Tax File Number"
            placeholder="Tax File Number"
            value={tfn}
            disabled
          />
          <FormField
            id="address_line1"
            label="Address"
            placeholder="Address"
            required
            value={props.user.address_line1}
            disabled
          />
        </div>
      </div>
    </>
  );
}

export default SuperForm;
